module.exports = Object.freeze({
    COORDINATOR: 'Invite Coordinator',
    GIVER: 'Invite Volunteer',
    RECEIVER: 'Include Senior',
});
